import { useParams } from "react-router-dom"
import Layout from "../../components/Layout/Layout"
import { useEffect, useState } from "react"
import locations from "../../locations"
import Headers from "../../components/Headers/Headers"
import LocationsBlog from "../../components/LocationsBlog/LocationsBlog"
import { Container } from "@mui/material"
import { Helmet } from "react-helmet-async"


function Lokality() {
    const { lokalita } = useParams()
    const [location, setLocation] = useState(null)
    useEffect(() => {
        const loc = locations.find(el => el.slug === lokalita)
        setLocation(loc)
        console.log(loc)
    }, [lokalita])

    if (location === undefined || !location) {
        return (
            <>
                <Layout>
                    <h1>Tato strának neexistuje</h1>
                </Layout>
            </>
        )
    }
    return (
        <>
            <Helmet>
                <title>RS Rent Stěhování {location.name} | Stěhovací služby a půjčovna vozů</title>
                <meta name="description" content={location.description} />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="canonical" href={`https://rsrent.cz/stehovani/${location.slug}`} />
            </Helmet>
            <Layout>
                <Headers>Stěhování {location.name}</Headers>
                <Container maxWidth="lg" sx={{
                    p: 3
                }}>
                    <LocationsBlog>{location.content}</LocationsBlog>
                </Container>
            </Layout>
        </>
    )
}

export default Lokality